// extracted by mini-css-extract-plugin
module.exports = {"root":"tS52Y"};